module.exports = __webpack_public_path__ + "static/media/37_A.5e05aa70.jpg";